import { createStore } from 'redux';
import rootReducer from '../reducers/index';

import { sourceData } from '../data';

const quizData = { ...sourceData };

if (quizData.hasOwnProperty('settings')) {
  delete quizData.settings;
}

export const configureStore = dataSet => {
  return {
    slideStatus: Object.keys(dataSet).reduce(
      (prev, curr, index) => ({
        ...prev,
        ...{ [index]: { completed: false } },
      }),
      {},
    ),
  };
};

export const firstState = {
  sliderDisabled: true,
  g: '',
  cr: '',
  cl: '',
  s: '',
  c: [],
};

const store = createStore(
  rootReducer,
  { ...firstState, ...configureStore(quizData) },
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
);

export default store;
